import React, { useEffect, useState } from 'react'
import { LoadingOutlined } from '@ant-design/icons'
import { Checkbox, Row, Select, Card, Form, Input, Radio, Spin, Col, Button, Space, Typography } from 'antd'
import InputMask from 'react-input-mask'
import { HeaderHero, SEO } from './components'
import { sendAgencyAppointmentApp } from '../services'
import { getDomain, getHostName } from '../utils'
import Router from 'next/router'
import { checkSelfService } from '../services/Api'

import AgencyApplicationFormStyle from '../../styles/AgencyApplicationForm.module.css'

const { Option } = Select
const { Text } = Typography

const antIcon = <LoadingOutlined spin style={{ fontSize: 24 }} />

const tabletImage = 'PartnerWithUsHeaderImage_1024x300.jpeg'
const desktopImage = 'PartnerWithUsHeaderImage_1440x300.jpeg'
const largeScreenImage = 'PartnerWithUsHeaderImage_1620x300.jpeg'
const xtraLargeScreenImage = 'PartnerWithUsHeaderImage_1960x300.jpeg'
const smallImage = 'PartnerWithUsHeaderImage_375x188.jpeg'
const smallImage390 = 'PartnerWithUsHeaderImage_390x188.jpeg'
const mobileImage = 'PartnerWithUsHeaderImage_428x188.jpeg'
const mobileImage768 = 'PartnerWithUsHeaderImage_768x300.jpeg'

const STATE_OPTIONS = [
    { value: "AL", label: "Alabama" },
    { value: "AK", label: "Alaska" },
    { value: "AZ", label: "Arizona" },
    { value: "AR", label: "Arkansas" },
    { value: "CA", label: "California" },
    { value: "CO", label: "Colorado" },
    { value: "CT", label: "Connecticut" },
    { value: "DE", label: "Delaware" },
    { value: "FL", label: "Florida" },
    { value: "GA", label: "Georgia" },
    { value: "HI", label: "Hawaii" },
    { value: "ID", label: "Idaho" },
    { value: "IL", label: "Illinois" },
    { value: "IN", label: "Indiana" },
    { value: "IA", label: "Iowa" },
    { value: "KS", label: "Kansas" },
    { value: "KY", label: "Kentucky" },
    { value: "LA", label: "Louisiana" },
    { value: "ME", label: "Maine" },
    { value: "MD", label: "Maryland" },
    { value: "MA", label: "Massachusetts" },
    { value: "MI", label: "Michigan" },
    { value: "MN", label: "Minnesota" },
    { value: "MS", label: "Mississippi" },
    { value: "MO", label: "Missouri" },
    { value: "MT", label: "Montana" },
    { value: "NE", label: "Nebraska" },
    { value: "NV", label: "Nevada" },
    { value: "NH", label: "New Hampshire" },
    { value: "NJ", label: "New Jersey" },
    { value: "NM", label: "New Mexico" },
    { value: "NY", label: "New York" },
    { value: "NC", label: "North Carolina" },
    { value: "ND", label: "North Dakota" },
    { value: "OH", label: "Ohio" },
    { value: "OK", label: "Oklahoma" },
    { value: "OR", label: "Oregon" },
    { value: "PA", label: "Pennsylvania" },
    { value: "RI", label: "Rhode Island" },
    { value: "SC", label: "South Carolina" },
    { value: "SD", label: "South Dakota" },
    { value: "TN", label: "Tennessee" },
    { value: "TX", label: "Texas" },
    { value: "UT", label: "Utah" },
    { value: "VT", label: "Vermont" },
    { value: "VA", label: "Virginia" },
    { value: "WA", label: "Washington" },
    { value: "WV", label: "West Virginia" },
    { value: "WI", label: "Wisconsin" },
    { value: "WY", label: "Wyoming" }
];

const AgencyApplicationForm = () => {
    const [application, setApplication] = useState({
        EmailAddress: '',
        FirstName: '',
        LastName: '',
        PhoneNumber: '',
        JobTitle: '',
        AgencyPrincipal: '',
        HearAboutUs: '',
        AgencyName: '',
        WebsiteURL: '',
        StreetAddress: '',
        City: '',
        State: '',
        Zip: '',
        HaveAdditionalLocations: '',
        NumberAdditionalLocations: '',
        WorkLocation: '',
        NumberProducers: '',
        LicensedStates: '',
        YearsInBusiness: '',
        UseAgencyManagementSystem: '',
        AgencyManagementSystemUsed: '',
        UseComparativeRaters: '',
        ComparativeRatersUsed: '',
        NonStandardApplicationsWrittenPerMonth: '',
        PercentageMinimumLiablityWritten: '',
        EstThreeYearTotalLossRatio: '',
        ForeignDLAccepted: '',
        PercentageForeignDLApplied: '',
        UseMobileApps: '',
        AcceptCash: '',
    })
    const [showSpinner, setShowSpinner] = useState(false)
    const [message, setMessage] = useState(null);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }

    // Force browser back button to /PartnerWithUs
    useEffect(() => {
        window.history.pushState(null, '', window.location.href);

        const handlePopState = () => {
            Router.push('/PartnerWithUs');
        };
        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [Router]);

    const handleSubmit = async () => {
        setMessage(null);
        setShowSpinner(true);
        if (isFormInValid()) {
            setMessage("Please complete all required fields.")
            setShowSpinner(false);
            return false;
        }
        const updatedApplication = { ...application };
        //console.log(updatedApplication);
        const response = await sendAgencyAppointmentApp(updatedApplication);
        if (response && response.data && response.data.Result === 'Appointment Created') {
            setShowSpinner(false);
            Router.push('/PartnerWithUs/submitted');
        }
        else {
            setMessage(response && response.data && response.data.Result ? response.data.Result : "An error has occured. Please try again later.");
            setShowSpinner(false);
        }
    }

    const updateTextFields = (text, field) => {
        const clonedApplication = { ...application }
        setApplication({
            ...clonedApplication,
            [field]: text
        })
    }

    const isFormInValid = () => {
        let response = false
        if (
            application.FirstName.length === 0 ||
            application.LastName.length === 0 ||
            application.EmailAddress.length === 0 ||
            application.PhoneNumber.length === 0 ||
            application.JobTitle.length === 0 ||
            application.AgencyPrincipal.length === 0 ||
            application.HearAboutUs.length === 0 ||
            application.AgencyName.length === 0 ||
            application.StreetAddress.length === 0 ||
            application.City.length === 0 ||
            application.State.length === 0 ||
            application.Zip.length === 0 ||
            application.HaveAdditionalLocations.length === 0 ||
            application.WorkLocation.length === 0 ||
            application.NumberProducers.length === 0 ||
            application.LicensedStates.length === 0 ||
            application.YearsInBusiness.length === 0 ||
            application.UseAgencyManagementSystem.length === 0 ||
            application.UseComparativeRaters.length === 0 ||
            application.NonStandardApplicationsWrittenPerMonth.length === 0 ||
            application.PercentageMinimumLiablityWritten.length === 0 ||
            application.EstThreeYearTotalLossRatio.length === 0 ||
            application.ForeignDLAccepted.length === 0 ||
            application.UseMobileApps.length === 0 ||
            application.AcceptCash.length === 0
        ) {
            response = true
        }
        if (!response) {
            if (application.EmailAddress.length > 0 && !/\S+@\S+\.\S+/.test(application.EmailAddress)) {
                response = true
            }
            if (application.Zip.length > 0 && !/^[0-9]+$/.test(application.Zip)) {
                response = true
            }
            if (application.HaveAdditionalLocations === "Yes" && application.NumberAdditionalLocations.length === 0) {
                response = true;
            }
            if (application.UseAgencyManagementSystem === "Yes" && application.AgencyManagementSystemUsed.length === 0) {
                response = true;
            }
            if (application.UseComparativeRaters === "Yes" && application.ComparativeRatersUsed.length === 0) {
                response = true;
            }
            if (application.ForeignDLAccepted === "Yes" && application.PercentageForeignDLApplied.length === 0) {
                response = true;
            }
        }
        return response
    }

    const handleKeyDown = event => {
        if (event.key === 'Enter' && !isFormInValid()) {
            handleSubmit()
        }
    }

    return (
        <>
            <SEO
                title={"Partner With Us | CURE Auto Insurance"}
                description={"Interested in becoming a CURE agent? Learn more about the CURE Agency Program and apply to be an appointed agent in Michigan, New Jersey, Pennsylvania, and Florida. "}
                url={"/PartnerWithUs/apply"}
            />
            <HeaderHero
                desktopImage={desktopImage}
                largeScreenImage={largeScreenImage}
                mobileImage={mobileImage}
                mobileImage768={mobileImage768}
                smallImage={smallImage}
                smallImage390={smallImage390}
                tabletImage={tabletImage}
                xtraLargeScreenImage={xtraLargeScreenImage}
                title="PARTNER WITH US"
            />
            <div className={`${AgencyApplicationFormStyle["agency-application-form-screen"]}`}>
                <Row>
                    <Card className={`${AgencyApplicationFormStyle["agency-application-form-card"]}`}>
                        <Row>
                            <Col span={24} className={`${AgencyApplicationFormStyle["title-container"]}`}>
                                <h5 className={`${AgencyApplicationFormStyle["title"]}`}>Partner with us and become an appointed agent</h5>
                                <p>Please complete the form below and a CURE Agency Representative will contact you within 1-2 business days.</p>
                            </Col>
                        </Row>
                        <h5 className={`${AgencyApplicationFormStyle["sub-label"]}`}>Your Information</h5>
                        <Row>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                                <Form.Item className={`${AgencyApplicationFormStyle["margin-bottom-14"]}`}>
                                    <Input
                                        autoComplete="off"
                                        className={`${AgencyApplicationFormStyle["input-text"]}`}
                                        onChange={event => updateTextFields(event.target.value, 'FirstName')}
                                        onKeyDown={handleKeyDown}
                                        placeholder="First Name*"
                                        value={application.FirstName}
                                        onBlur={event => updateTextFields(event.target.value.trim(), 'FirstName')}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                                <Form.Item className={`${AgencyApplicationFormStyle["margin-bottom-14"]}`}>
                                    <Input
                                        autoComplete="off"
                                        className={`${AgencyApplicationFormStyle["input-text"]}`}
                                        onChange={event => updateTextFields(event.target.value, 'LastName')}
                                        onKeyDown={handleKeyDown}
                                        placeholder="Last Name*"
                                        value={application.LastName}
                                        onBlur={event => updateTextFields(event.target.value.trim(), 'LastName')}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                                <Form.Item className={`${AgencyApplicationFormStyle["margin-bottom-14"]}`}>
                                    <InputMask
                                        type="tel" pattern="[0-9]*" inputMode="numeric"
                                        className={`${AgencyApplicationFormStyle["input-text"]} ${AgencyApplicationFormStyle["phone-number"]}`}
                                        mask="(999) 999-9999"
                                        placeholder="Phone Number*"
                                        onKeyDown={handleKeyDown}
                                        onChange={event => updateTextFields(event.target.value, 'PhoneNumber')}
                                        value={application.PhoneNumber}
                                        onBlur={event => updateTextFields(event.target.value.trim(), 'PhoneNumber')}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                                <Form.Item className={`${AgencyApplicationFormStyle["margin-bottom-14"]}`}>
                                    <Input
                                        autoComplete="off"
                                        className={`${AgencyApplicationFormStyle["input-text"]}`}
                                        onChange={event => updateTextFields(event.target.value, 'EmailAddress')}
                                        onKeyDown={handleKeyDown}
                                        placeholder="Email Address*"
                                        value={application.EmailAddress}
                                        onBlur={event => updateTextFields(event.target.value.trim(), 'EmailAddress')}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                                <Form.Item className={`${AgencyApplicationFormStyle["margin-bottom-14"]}`}>
                                    <Input
                                        autoComplete="off"
                                        className={`${AgencyApplicationFormStyle["input-text"]}`}
                                        onChange={event => updateTextFields(event.target.value, 'JobTitle')}
                                        onKeyDown={handleKeyDown}
                                        placeholder="Job Title*"
                                        value={application.JobTitle}
                                        onBlur={event => updateTextFields(event.target.value.trim(), 'JobTitle')}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Text style={{ fontSize: "20px" }}>
                                    Are you an Agency Principal?* {`  `}</Text>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                                <Radio.Group
                                    className={`${AgencyApplicationFormStyle["margin-bottom-14"]}`}
                                    onChange={event => updateTextFields(event.target.value, 'AgencyPrincipal')}
                                    value={application.AgencyPrincipal}
                                >
                                    <Radio value="Yes">Yes</Radio>
                                    <Radio value="No">No</Radio>
                                </Radio.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Text style={{ fontSize: "20px" }}>
                                    How did you hear about us?* {`  `}</Text>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                                <Form.Item className={`${AgencyApplicationFormStyle["margin-bottom-14"]}`}>
                                    <Input
                                        autoComplete="off"
                                        className={`${AgencyApplicationFormStyle["input-text"]}`}
                                        onChange={event => updateTextFields(event.target.value, 'HearAboutUs')}
                                        onKeyDown={handleKeyDown}
                                        value={application.HearAboutUs}
                                        onBlur={event => updateTextFields(event.target.value.trim(), 'HearAboutUs')}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <hr />
                            </Col>
                        </Row>
                        <h5 className={`${AgencyApplicationFormStyle["sub-label"]}`}>Agency Information</h5>
                        <Row>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                                <Form.Item className={`${AgencyApplicationFormStyle["margin-bottom-14"]}`}>
                                    <Input
                                        autoComplete="off"
                                        className={`${AgencyApplicationFormStyle["input-text"]}`}
                                        onChange={event => updateTextFields(event.target.value, 'AgencyName')}
                                        onKeyDown={handleKeyDown}
                                        placeholder="Company Name*"
                                        value={application.AgencyName}
                                        onBlur={event => updateTextFields(event.target.value.trim(), 'AgencyName')}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                                <Form.Item className={`${AgencyApplicationFormStyle["margin-bottom-14"]}`}>
                                    <Input
                                        autoComplete="off"
                                        className={`${AgencyApplicationFormStyle["input-text"]}`}
                                        onChange={event => updateTextFields(event.target.value, 'WebsiteURL')}
                                        onKeyDown={handleKeyDown}
                                        placeholder="Website URL"
                                        type='url'
                                        value={application.WebsiteURL}
                                        onBlur={event => updateTextFields(event.target.value.trim(), 'WebsiteURL')}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                                <Form.Item className={`${AgencyApplicationFormStyle["margin-bottom-14"]}`}>
                                    <Input
                                        autoComplete="off"
                                        className={`${AgencyApplicationFormStyle["input-text"]}`}
                                        onChange={event => updateTextFields(event.target.value, 'StreetAddress')}
                                        placeholder="Street Address*"
                                        value={application.StreetAddress}
                                        onBlur={event => updateTextFields(event.target.value.trim(), 'StreetAddress')}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl={{ span: 5 }} xs={{ span: 24 }}>
                                <Form.Item className={`${AgencyApplicationFormStyle["margin-bottom-14"]}`}>
                                    <Input
                                        autoComplete="off"
                                        className={`${AgencyApplicationFormStyle["input-text"]}`}
                                        placeholder="City*"
                                        onChange={event => updateTextFields(event.target.value, 'City')}
                                        value={application.City}
                                        onBlur={event => updateTextFields(event.target.value.trim(), 'City')}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                                <Form.Item className={`${AgencyApplicationFormStyle["margin-bottom-14"]}`}>
                                    <Select
                                        showSearch
                                        autoComplete="off"
                                        placeholder="State*"
                                        value={application.State || undefined}
                                        className={`${AgencyApplicationFormStyle["input-text-2"]}`}
                                        onChange={value => updateTextFields(value, 'State')}
                                        optionFilterProp="label"
                                        filterOption={(input, option) =>
                                            (option?.label ?? "").toLowerCase().includes(input.toLowerCase()) ||
                                            (option?.value ?? "").toLowerCase().includes(input.toLowerCase())
                                        }
                                    >
                                        {STATE_OPTIONS.map((obj, index) => (
                                            <Select.Option
                                                key={index}
                                                value={obj.value}
                                                label={obj.label}
                                            >
                                                {obj.label}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                                <Form.Item className={`${AgencyApplicationFormStyle["margin-bottom-14"]}`}>
                                    <Input
                                        type="tel" pattern="[0-9]*" inputmode="numeric"
                                        autoComplete="off"
                                        className={`${AgencyApplicationFormStyle["input-text"]}`}
                                        placeholder="Zip Code*"
                                        maxLength="5"
                                        value={application.Zip}
                                        onChange={event => {
                                            const value = event.target.value.replace(/\D/g, ''); 
                                            updateTextFields(value, 'Zip')
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Text style={{ fontSize: "20px" }}>
                                    Do you have additional locations?* {`  `}</Text>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                                <Radio.Group
                                    className={`${AgencyApplicationFormStyle["margin-bottom-14"]}`}
                                    onChange={event => updateTextFields(event.target.value, 'HaveAdditionalLocations')}
                                    value={application.HaveAdditionalLocations}
                                >
                                    <Radio value="Yes">Yes</Radio>
                                    <Radio value="No">No</Radio>
                                </Radio.Group>
                            </Col>
                        </Row>
                        {application.HaveAdditionalLocations === "Yes" && (
                            <>
                                <Row>
                                    <Col span={24}>
                                        <Text style={{ fontSize: "20px" }}>
                                            How many other locations?*{`  `}</Text>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                                        <Form.Item className={`${AgencyApplicationFormStyle["margin-bottom-14"]}`}>
                                            <Input
                                                autoComplete="off"
                                                className={`${AgencyApplicationFormStyle["input-text"]}`}
                                                onChange={event => updateTextFields(event.target.value, 'NumberAdditionalLocations')}
                                                onKeyDown={handleKeyDown}
                                                value={application.NumberAdditionalLocations}
                                                onBlur={event => updateTextFields(event.target.value.trim(), 'NumberAdditionalLocations')}
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </>
                        )}
                        <Row>
                            <Col span={24}>
                                <Text style={{ fontSize: "20px" }}>
                                    Do you work from a residential or office location?* {`  `}</Text>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                                <Form.Item className={`${AgencyApplicationFormStyle["margin-bottom-14"]}`}>
                                    <Select
                                        showSearch
                                        autoComplete="off"
                                        placeholder="Select..."
                                        value={application.WorkLocation || undefined}
                                        className={`${AgencyApplicationFormStyle["input-text-2"]}`}
                                        onChange={value => updateTextFields(value, 'WorkLocation')}
                                        optionFilterProp="label"
                                        filterOption={(input, option) =>
                                            (option?.label ?? "").toLowerCase().includes(input.toLowerCase()) ||
                                            (option?.value ?? "").toLowerCase().includes(input.toLowerCase())
                                        }
                                    >
                                        <Select.Option
                                            value="I work out of my residence"
                                            label="I work out of my residence"
                                        >
                                            I work out of my residence
                                        </Select.Option>
                                        <Select.Option
                                            value="I have a retail storefront"
                                            label="I have a retail storefront"
                                        >
                                            I have a retail storefront
                                        </Select.Option>
                                        <Select.Option
                                            value="I work out of a commercial space"
                                            label="I work out of a commercial space"
                                        >
                                            I work out of a commercial space
                                        </Select.Option>
                                        <Select.Option
                                            value="I work in an office space shared with other businesses"
                                            label="I work in an office space shared with other businesses"
                                        >
                                            I work in an office space shared with other businesses
                                        </Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Text style={{ fontSize: "20px" }}>
                                    How many producers work in the Agency?* {`  `}</Text>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                                <Form.Item className={`${AgencyApplicationFormStyle["margin-bottom-14"]}`}>
                                    <Select
                                        showSearch
                                        autoComplete="off"
                                        placeholder="Select..."
                                        value={application.NumberProducers || undefined}
                                        className={`${AgencyApplicationFormStyle["input-text-2"]}`}
                                        onChange={value => updateTextFields(value, 'NumberProducers')}
                                        optionFilterProp="label"
                                        filterOption={(input, option) =>
                                            (option?.label ?? "").toLowerCase().includes(input.toLowerCase()) ||
                                            (option?.value ?? "").toLowerCase().includes(input.toLowerCase())
                                        }
                                    >
                                        <Select.Option
                                            value="0-5"
                                            label="0-5"
                                        >
                                            0-5
                                        </Select.Option>
                                        <Select.Option
                                            value="6-10"
                                            label="6-10"
                                        >
                                            6-10
                                        </Select.Option>
                                        <Select.Option
                                            value="11-15"
                                            label="11-15"
                                        >
                                            11-15
                                        </Select.Option>
                                        <Select.Option
                                            value="16+"
                                            label="16+"
                                        >
                                            16+
                                        </Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Text style={{ fontSize: "20px" }}>
                                    In which states is your Agency currently licensed to offer auto insurance policies?* {`  `}</Text>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                                <Form.Item className={`${AgencyApplicationFormStyle["margin-bottom-14"]}`}>
                                    <Input
                                        autoComplete="off"
                                        className={`${AgencyApplicationFormStyle["input-text"]}`}
                                        onChange={event => updateTextFields(event.target.value, 'LicensedStates')}
                                        onKeyDown={handleKeyDown}
                                        value={application.LicensedStates}
                                        onBlur={event => updateTextFields(event.target.value.trim(), 'LicensedStates')}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Text style={{ fontSize: "20px" }}>
                                    How many years has your Agency been in business?* {`  `}</Text>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                                <Form.Item className={`${AgencyApplicationFormStyle["margin-bottom-14"]}`}>
                                    <Input
                                        autoComplete="off"
                                        className={`${AgencyApplicationFormStyle["input-text"]}`}
                                        onChange={event => updateTextFields(event.target.value, 'YearsInBusiness')}
                                        onKeyDown={handleKeyDown}
                                        value={application.YearsInBusiness}
                                        onBlur={event => updateTextFields(event.target.value.trim(), 'YearsInBusiness')}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Text style={{ fontSize: "20px" }}>
                                    Does your Agency use an Agency Management System (AMS)?* {`  `}</Text>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                                <Radio.Group
                                    className={`${AgencyApplicationFormStyle["margin-bottom-14"]}`}
                                    onChange={event => updateTextFields(event.target.value, 'UseAgencyManagementSystem')}
                                    value={application.UseAgencyManagementSystem}
                                >
                                    <Radio value="Yes">Yes</Radio>
                                    <Radio value="No">No</Radio>
                                </Radio.Group>
                            </Col>
                        </Row>
                        {application.UseAgencyManagementSystem === "Yes" && (
                            <>
                                <Row>
                                    <Col span={24}>
                                        <Text style={{ fontSize: "20px" }}>
                                            Which AMS does your Agency use?*{`  `}</Text>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                                        <Form.Item className={`${AgencyApplicationFormStyle["margin-bottom-14"]}`}>
                                            <Input
                                                autoComplete="off"
                                                className={`${AgencyApplicationFormStyle["input-text"]}`}
                                                onChange={event => updateTextFields(event.target.value, 'AgencyManagementSystemUsed')}
                                                onKeyDown={handleKeyDown}
                                                value={application.AgencyManagementSystemUsed}
                                                onBlur={event => updateTextFields(event.target.value.trim(), 'AgencyManagementSystemUsed')}
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </>
                        )}
                        <Row>
                            <Col span={24}>
                                <Text style={{ fontSize: "20px" }}>
                                    Does your Agency use a Comparative Rater?* {`  `}</Text>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                                <Radio.Group
                                    className={`${AgencyApplicationFormStyle["margin-bottom-14"]}`}
                                    onChange={event => updateTextFields(event.target.value, 'UseComparativeRaters')}
                                    value={application.UseComparativeRaters}
                                >
                                    <Radio value="Yes">Yes</Radio>
                                    <Radio value="No">No</Radio>
                                </Radio.Group>
                            </Col>
                        </Row>
                        {application.UseComparativeRaters === "Yes" && (
                            <>
                                <Row>
                                    <Col span={24}>
                                        <Text style={{ fontSize: "20px" }}>
                                            Which Rater does your Agency use?*{`  `}</Text>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                                        <Form.Item className={`${AgencyApplicationFormStyle["margin-bottom-14"]}`}>
                                            <Input
                                                autoComplete="off"
                                                className={`${AgencyApplicationFormStyle["input-text"]}`}
                                                onChange={event => updateTextFields(event.target.value, 'ComparativeRatersUsed')}
                                                onKeyDown={handleKeyDown}
                                                value={application.ComparativeRatersUsed}
                                                onBlur={event => updateTextFields(event.target.value.trim(), 'ComparativeRatersUsed')}
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </>
                        )}
                        <Row>
                            <Col span={24}>
                                <hr />
                            </Col>
                        </Row>
                        <h5 className={`${AgencyApplicationFormStyle["sub-label"]}`}>Quoting & Policies</h5>
                        <Row>
                            <Col span={24}>
                                <Text style={{ fontSize: "20px" }}>
                                    Approximately how many non-standard auto applications does your Agency write per month?* {`  `}</Text>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                                <Form.Item className={`${AgencyApplicationFormStyle["margin-bottom-14"]}`}>
                                    <Input
                                        autoComplete="off"
                                        className={`${AgencyApplicationFormStyle["input-text"]}`}
                                        onChange={event => updateTextFields(event.target.value, 'NonStandardApplicationsWrittenPerMonth')}
                                        onKeyDown={handleKeyDown}
                                        value={application.NonStandardApplicationsWrittenPerMonth}
                                        onBlur={event => updateTextFields(event.target.value.trim(), 'NonStandardApplicationsWrittenPerMonth')}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Text style={{ fontSize: "20px" }}>
                                    What percentage of your agency&apos;s auto policies are written with the minimum liability limits?*{`  `}</Text>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                                <Form.Item className={`${AgencyApplicationFormStyle["margin-bottom-14"]}`}>
                                    <Select
                                        showSearch
                                        autoComplete="off"
                                        placeholder="Select..."
                                        className={`${AgencyApplicationFormStyle["input-text-2"]}`}
                                        value={application.PercentageMinimumLiablityWritten || undefined}
                                        onChange={value => updateTextFields(value, 'PercentageMinimumLiablityWritten')}
                                        optionFilterProp="label"
                                        filterOption={(input, option) =>
                                            (option?.label ?? "").toLowerCase().includes(input.toLowerCase()) ||
                                            (option?.value ?? "").toLowerCase().includes(input.toLowerCase())
                                        }
                                    >
                                        <Select.Option
                                            value="0-25%"
                                            label="0-25%"
                                        >
                                            0-25%
                                        </Select.Option>
                                        <Select.Option
                                            value="26-50%"
                                            label="26-50%"
                                        >
                                            26-50%
                                        </Select.Option>
                                        <Select.Option
                                            value="51-75%"
                                            label="51-75%"
                                        >
                                            51-75%
                                        </Select.Option>
                                        <Select.Option
                                            value="Over 75%"
                                            label="Over 75%"
                                        >
                                            Over 75%
                                        </Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Text style={{ fontSize: "20px" }}>
                                    What is your agency&apos;s estimated 3 year total loss ratio?*{`  `}</Text>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                                <Form.Item className={`${AgencyApplicationFormStyle["margin-bottom-14"]}`}>
                                    <Select
                                        showSearch
                                        autoComplete="off"
                                        placeholder="Select..."
                                        className={`${AgencyApplicationFormStyle["input-text-2"]}`}
                                        value={application.EstThreeYearTotalLossRatio || undefined}
                                        onChange={value => updateTextFields(value, 'EstThreeYearTotalLossRatio')}
                                        optionFilterProp="label"
                                        filterOption={(input, option) =>
                                            (option?.label ?? "").toLowerCase().includes(input.toLowerCase()) ||
                                            (option?.value ?? "").toLowerCase().includes(input.toLowerCase())
                                        }
                                    >
                                        <Select.Option
                                            value="Under 40%"
                                            label="Under 40%"
                                        >
                                            Under 40%
                                        </Select.Option>
                                        <Select.Option
                                            value="41-50%"
                                            label="41-50%"
                                        >
                                            41-50%
                                        </Select.Option>
                                        <Select.Option
                                            value="51-60%"
                                            label="51-60%"
                                        >
                                            51-60%
                                        </Select.Option>
                                        <Select.Option
                                            value="Over 60%"
                                            label="Over 60%"
                                        >
                                            Over 60%
                                        </Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Text style={{ fontSize: "20px" }}>
                                    Does your Agency provide policies for customers with a foreign driver&apos;s license?*{`  `}</Text>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                                <Radio.Group
                                    className={`${AgencyApplicationFormStyle["margin-bottom-14"]}`}
                                    onChange={event => updateTextFields(event.target.value, 'ForeignDLAccepted')}
                                    value={application.ForeignDLAccepted}
                                >
                                    <Radio value="Yes">Yes</Radio>
                                    <Radio value="No">No</Radio>
                                </Radio.Group>
                            </Col>
                        </Row>
                        {application.ForeignDLAccepted === "Yes" && (
                            <>
                                <Row>
                                    <Col span={24}>
                                        <Text style={{ fontSize: "20px" }}>
                                            What % of your total applications?*{`  `}</Text>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                                        <Form.Item className={`${AgencyApplicationFormStyle["margin-bottom-14"]}`}>
                                            <Input
                                                autoComplete="off"
                                                className={`${AgencyApplicationFormStyle["input-text"]}`}
                                                onChange={event => updateTextFields(event.target.value, 'PercentageForeignDLApplied')}
                                                onKeyDown={handleKeyDown}
                                                value={application.PercentageForeignDLApplied}
                                                onBlur={event => updateTextFields(event.target.value.trim(), 'PercentageForeignDLApplied')}
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </>
                        )}
                        <Row>
                            <Col span={24}>
                                <Text style={{ fontSize: "20px" }}>
                                    Do your customers typically use mobile apps to manage their auto insurance?*{`  `}</Text>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                                <Radio.Group
                                    className={`${AgencyApplicationFormStyle["margin-bottom-14"]}`}
                                    onChange={event => updateTextFields(event.target.value, 'UseMobileApps')}
                                    value={application.UseMobileApps}
                                >
                                    <Radio value="Yes">Yes</Radio>
                                    <Radio value="No">No</Radio>
                                </Radio.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Text style={{ fontSize: "20px" }}>
                                    Do you accept cash at your location(s)?*{`  `}</Text>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                                <Radio.Group
                                    className={`${AgencyApplicationFormStyle["margin-bottom-14"]}`}
                                    onChange={event => updateTextFields(event.target.value, 'AcceptCash')}
                                    value={application.AcceptCash}
                                >
                                    <Radio value="Yes">Yes</Radio>
                                    <Radio value="No">No</Radio>
                                </Radio.Group>
                            </Col>
                        </Row>
                        <Row className={`${AgencyApplicationFormStyle["submit-container"]}`}>
                            <Form.Item className={`${AgencyApplicationFormStyle["btn-control"]} ${AgencyApplicationFormStyle["button-submit-form"]}`}>
                                {message && (
                                    <Row>
                                        <Space style={{ marginBottom: "16px" }}>
                                            <Text style={{ color: "red", fontSize: "19px" }}>{message}</Text>
                                        </Space>
                                    </Row>
                                )}
                                <Space>
                                    <Button
                                        className={`${AgencyApplicationFormStyle["agency-application-form"]} ${AgencyApplicationFormStyle["agency-application-form-form-button"]}`}
                                        onClick={() => handleSubmit()}
                                    >
                                        Submit
                                    </Button>
                                    {showSpinner && <Spin indicator={antIcon} style={{ marginLeft: 24 }} />}
                                </Space>
                            </Form.Item>
                        </Row>
                    </Card>
                </Row>
            </div>
        </>
    )
}

AgencyApplicationForm.propTypes = {}

export default AgencyApplicationForm
